// MODULES
import React from "react";
import api from "../../../../helpers/api";
import EditableField from "../../components/EditableField/EditableField";
import Select from "../../../../components/Select/Select";
import NumberField from "../../components/NumberField/NumberField";

/**
 * Class holding code that is shared by all autogiro implementations.
 */
export default class AbstractAutogiro extends React.PureComponent {

	static companyExclusive = false;
	static privateExclusive = false;

	async componentDidMount() {
		/**
		 * Fetch the list of products that are available for purchase
		 */
		try {
			console.log("Loading products for autogiro...");
			const newStateProps = {};
			newStateProps.products = await api("/case/products", {
				authToken: this.authToken
			});
			this.setState(newStateProps);
		}
		catch (e) {
			console.log(e);
		}
	}

	_isValidBankAccountNo(doAdvancedValidation, accountNumber, clearingNumber) {
		if (accountNumber.length === 0) {
			return false;
		}

		if (doAdvancedValidation) {
			let bankNoToValidate = clearingNumber + ", " + accountNumber;
			let kontonummer = window.kontonummer(bankNoToValidate);
			return kontonummer !== false;
		}

		const replacedValue = accountNumber.split(" ").join("");
		return replacedValue.length > 5 && !isNaN(replacedValue);
	}
}

export function ProductSelectionRow(parent, isFund, minimumSingleDeposit, minimumMonthlyDeposit, funds, rowType, i) {

	const selectedFundsArray = rowType === "single" ? "customer_autogiro_single_funds" : "customer_autogiro_monthly_funds";
	const selectedFundsArrayItemPrefix = rowType === "single" ? "customer_autogiro_single_" : "customer_autogiro_monthly_";
	const selectedFundAssetPrefix = rowType === "single" ? "advice_asset_single_" : "advice_asset_monthly_";
	const selectedFundTypePercentageTotal = rowType === "single" ? "autogiroSingleFundsSharesTotal" : "autogiroMonthlyFundsSharesTotal";

	const dropdownLabel = isFund ? "Sök på namn eller ISIN" : "Sök på namn";

	let fundAmount = 0;
	const fundPercentage = parent.state.fields[selectedFundsArray][i - 1][selectedFundsArrayItemPrefix + "fund_" + i + "_percentage"] || 0;
	if (parent.state.fields[selectedFundsArrayItemPrefix + "amount"] && parent.state.fields[selectedFundsArrayItemPrefix + "amount"] > 0 && fundPercentage > 0) {
		fundAmount = parent.state.fields[selectedFundsArrayItemPrefix + "amount"] * (fundPercentage / 100);
		fundAmount = Math.round(fundAmount * 100) / 100;
	}

	const fundName = parent.state.fields[selectedFundsArray][i - 1][selectedFundsArrayItemPrefix + "fund_" + i + "_name"] || "";
	const fundIsin = parent.state.fields[selectedFundsArray][i - 1][selectedFundsArrayItemPrefix + "fund_" + i + "_isin"] || "";

	let rowIsEditable = true;
	if (rowType === "single") {
		rowIsEditable = parent.state.validFields.customer_autogiro_single_amount && parent.state.fields.customer_autogiro_single_amount >= minimumSingleDeposit;
	}
	else {
		rowIsEditable = parent.state.validFields.customer_autogiro_monthly_amount && parent.state.fields.customer_autogiro_monthly_amount >= minimumMonthlyDeposit;
	}

	let fundAmountForDisplay;
	if (fundAmount >= 0) {
		fundAmountForDisplay = fundAmount.toLocaleString("sv-SE", {minimumFractionDigits: 0}) + " SEK";
	}
	else {
		fundAmountForDisplay = "Felaktigt belopp";
	}

	return (
		<div className="fund" key={rowType + "_" + i}>

			<div className="fundLabel">
				{parent._getProductLabel() + " " + i}
			</div>

			<EditableField
				label={dropdownLabel}
				Component={Select}
				disabled={!rowIsEditable}
				selectedIndex={parent.state[selectedFundsArrayItemPrefix + "fund_" + i + "_index"]}
				customFilterer={parent._nameIsinFilterer}
				renderOption={parent._renderNameIsinOption}
				valid={parent.state.validFields[selectedFundsArrayItemPrefix + "fund_" + i + "_name"] && parent.state.validFields[selectedFundsArrayItemPrefix + "fund_" + i + "_name"] !== ""}
				onChange={parent._onNameIsinChange.bind(parent, selectedFundsArrayItemPrefix + "fund_" + i + "_name")}
				options={funds}
			/>

			<EditableField
				name={(i - 1) + "_" + selectedFundsArrayItemPrefix + "fund_" + i + "_percentage"}
				label="Andel"
				disabled={!rowIsEditable}
				Component={NumberField}
				value={fundPercentage}
				unit="%"
				valid={parent.state[selectedFundTypePercentageTotal] === 100}
				onChange={parent._onPercentageSingleFieldChange}
				onBlur={parent._onFieldBlur}
			/>

			<div className="amountLabel">
				<span>Belopp</span>
				{
					parent.state[selectedFundTypePercentageTotal] === 100 ? fundAmountForDisplay : "-"
				}
			</div>

			<input type="hidden" name={selectedFundAssetPrefix + "name_" + i} value={fundName}/>
			<input type="hidden" name={selectedFundAssetPrefix + "isin_" + i} value={fundIsin}/>
			<input type="hidden" name={selectedFundAssetPrefix + "share_" + i} value={fundPercentage}/>
		</div>
	);
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Autogiro/AbstractAutogiro.js